// extracted by mini-css-extract-plugin
export default {"avatar":"avatar-setting_avatar__GDqn0","edit":"avatar-setting_edit__afjRc"};